module.exports = __webpack_public_path__ + "static/media/singleProductImg3.46460f7e.jpg";